
export let SPSToken = "";
export let SPSDrive = null;

/**
 * set share point token
 * @param {*} token 
 */
export const setSPSToken = token => {
	SPSToken = token;
};

/**
 * fetch share point token data
 * @param {*} token 
 * @returns 
 */
export const getSPSTokenData = () => {
	return SPSToken;
};

/**
 * drive list - share point
 * @param {*} driveList 
 */
export const setSPSDrive = driveList => {
	SPSDrive = driveList;
};

/** Downloading statuses */
export const DOWNLOAD_STATUS = {
	inProgress: "progress",
	downloading: "downloading",
	completed: "completed",
	failed: "failed",
	uploading: "uploading",
	uploaded: "uploaded"
};
